module.exports = __webpack_public_path__ + "static/img/baccarat_en.654d42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/baccarat_en.png
// module id = 6Q5H
// module chunks = 1